import React, { useState } from 'react';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { StaticImage } from 'gatsby-plugin-image';
import {
  CaretImage,
  LanguageText,
  LanguageButtonContainer,
  LanguageSelectedButtonContainer,
  LanguageOptionButtonContainer,
  LanguageX,
} from './LanguageButton.Styles';
import QueryStringNavigate from '../QueryStringNavigate';
import arrowDownimg from '../../../static/images/arrowDown.png';
import * as urlHelper from '../../helpers/url.helper';

const LanguageButton = ({ translations, isGatsbyPage }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLanguageSelectedClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLanguageOptionClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  if (
    translations &&
    Array.isArray(translations) &&
    translations.length === 0 &&
    !isGatsbyPage
  ) {
    return null;
  }

  const params = {};

  if (typeof window !== 'undefined') {
    window.location.search.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      (str, key, value) => {
        params[key] = value;
      },
    );
  }

  const { languages, path, language } = useI18next();
  // originalPath has confilcts with routres starting with enxxxxx
  let parsedPath = `${path}${params.id ? `?id=${params.id}` : ''}`;
  if (parsedPath.includes('/en/')) {
    parsedPath = parsedPath.replace('/en/', '/');
  }

  if (Array.isArray(translations) && translations.length > 0) {
    const uri = translations[0].uri.includes('/en/')
      ? translations[0].uri.replace('/en/', '/')
      : translations[0].uri;
    parsedPath = `${uri}${params.id ? `?id=${params.id}` : ''}`;
  }
  const littleWordimg = '../../../static/images/littleWord.png';
  return (
    <LanguageX>
      <LanguageButtonContainer>
        <LanguageSelectedButtonContainer onClick={handleLanguageSelectedClick}>
          <StaticImage src={littleWordimg} alt="" />
          <LanguageText>{language}</LanguageText>
          <CaretImage
            isDropdownOpen={isDropdownOpen}
            src={arrowDownimg}
            alt=""
          />
        </LanguageSelectedButtonContainer>
        {languages.map((lng) => {
          if (lng === language) {
            return null;
          }
          const path = urlHelper.getPathForOtherLanguage(parsedPath, lng);
          return (
            <LanguageOptionButtonContainer
              key={lng}
              onClick={() =>
                handleLanguageOptionClick({ languageClicked: language })
              }
              isDropdownOpen={isDropdownOpen}
            >
              <QueryStringNavigate
                key={lng}
                path={path}
                languageChange={lng}
                style={{
                  width: '100%',
                  height: '31px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingLeft: '14px',
                  cursor: 'pointer',
                  fontFamily: 'DM-Sans',
                  textDecoration: 'none',
                }}
              >
                {lng}
              </QueryStringNavigate>
            </LanguageOptionButtonContainer>
          );
        })}
      </LanguageButtonContainer>
    </LanguageX>
  );
};

export default LanguageButton;
